import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Advisor as IAdvisor } from '../../../../interfaces/Advisors';
import { StyledDiv } from './Content.styles';
import { StyledLinePrompt } from '../../HeadOfficeTile/HeadOfficeTile.styles';
import Advisor from './Advisor';
import Agency from './Agency';

export interface ContentProps {
  advisor: IAdvisor;
}

const Content: FC<ContentProps> = ({ advisor }) => {
  const { t } = useTranslation('ContactUsPage');

  return (
    <StyledDiv>
      <Advisor advisor={advisor} />
      <Agency advisor={advisor} />
      {(advisor?.agency?.email || advisor?.email) &&
        <StyledLinePrompt>{t('emailPrompt')}</StyledLinePrompt>}
    </StyledDiv>
  );
};

export default Content;
